import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './App.css';
import 'typeface-roboto';
import Navbar from './components/Navbar';

import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Modal from 'react-modal';
import Typography from '@mui/material/Typography';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

// Import data for exercises
import exercises from './data/exercises'

//Import data for accessories
import accessories from './data/accessories'

var appElement = document.getElementById('example');

Modal.setAppElement(appElement);

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

class WodGenerator extends React.Component {
  constructor(props) {
    super(props);
    this.state = { modalIsOpen: false };
  }

  openModal = () => {
    this.setState({modalIsOpen: true});
  }

  closeModal = () => {
    this.setState({modalIsOpen: false});
  }
  
  openSnackbar = () => {
    this.setState({snackbarIsOpen: true});
  }

  closeSnackbar = () => {
    this.setState({snackbarIsOpen: false});
  }

  handleModalCloseRequest = () => {
    // opportunity to validate something and keep the modal open even if it
    // requested to be closed
    this.setState({modalIsOpen: false});
  }

  handleSnackbarCloseRequest = () => {
    // opportunity to validate something and keep the snackbar open even if it
    // requested to be closed
    this.setState({snackbarIsOpen: false});
  }

  state = {
    wodTitle: ""
  }

  getExercise(type) {
    // Loop to pick an exercise that matches the filter. 
    while (true) {
      var exercise = exercises[Math.floor((Math.random() * exercises.length) + 0)];

      // See if it's applicable to the type filter, if not try another one.
      if (exercise.type.includes(type)) {
        return exercise;
      }
    }
  }

  getAccessory(type) {
    // Loop to pick an accessory that matches the filter. 
    while (true) {
      var accessory = accessories[Math.floor((Math.random() * accessories.length) + 0)];

      // See if it's applicable to the type filter, if not try another one.
      if (accessory.type.includes(type)) {
        return accessory;
      }
    }
  }

  genAmrap() {
    var numExercises = Math.floor((Math.random() * 3) + 2);
    var selectedExercises = [];
    var exercises = [];

    // Calculate the time cap with a min of 20 and max of 30 minutes
    var wodTitle = "Complete as many rounds as possible in " + Math.floor((Math.random() * 10) + 20) + " minutes of: ";
    for (var i = 0; i < numExercises; i++) {

      // Get the Exercise (Make sure it's not duplicated)
      var exercise = this.getExercise("amrap");
      while (selectedExercises.includes(exercise.name)) {
        exercise = this.getExercise("amrap");
      }
      selectedExercises.push(exercise.name);

      // Calculate the Exercise rep range, and the weight (light, normal, heavy)
      var exerciseDesc = "";
      if (exercise.repRange) {
        var reps = Math.floor((Math.random() * (exercise.repRange[1] - exercise.repRange[0])) + exercise.repRange[0]);
        exerciseDesc += reps + " ";
      }
      exerciseDesc += exercise.name;

      // if there's a weight associated, add it
      if (exercise.weights) {
        exerciseDesc += " " + exercise.weights[1] + "#";
      }
      exercises.push(exerciseDesc);
    }
    return (<div>
      <b>{wodTitle}</b><br />
      {exercises.map((ex) => (
        <div>{ex}</div>
      ))}
    </div>);

  }

  genForTime() {
    var numExercises = Math.floor((Math.random() * 3) + 3);
    var selectedExercises = [];
    var exercises = [];

    // Calculate the number of rounds
    var wodTitle = Math.floor((Math.random() * 4) + 3) + " rounds of: ";
    for (var i = 0; i < numExercises; i++) {

      // Get the Exercise (Make sure it's not duplicated)
      var exercise = this.getExercise("time");
      while (selectedExercises.includes(exercise.name)) {
        exercise = this.getExercise("time");
      }
      selectedExercises.push(exercise.name);

      // Calculate the Exercise rep range, and the weight (light, normal, heavy)
      var exerciseDesc = "";
      if (exercise.repRange) {
        var reps = Math.floor((Math.random() * (exercise.repRange[1] - exercise.repRange[0])) + exercise.repRange[0]);
        exerciseDesc += reps + " ";
      }
      exerciseDesc += exercise.name;

      // if there's a weight associated, add it
      if (exercise.weights) {
        exerciseDesc += " " + exercise.weights[1] + "#";
      }

      exercises.push(exerciseDesc);
    }
    return (<div>
      <b>{wodTitle}</b><br />
      {exercises.map((ex) => (
        <div>{ex}</div>
      ))}
    </div>);
  }

  genEmom() {
    var numExercises = Math.floor((Math.random() * 1) + 2);
    var selectedExercises = [];
    var exercises = [];

    // Calculate the time cap with a min of 20 and max of 30 minutes
    var wodTitle = "Every minute on the minute for " + Math.floor((Math.random() * 10) + 20) + " minutes: ";
    for (var i = 0; i < numExercises; i++) {

      // Get the Exercise (Make sure it's not duplicated)
      var exercise = this.getExercise("emom");
      while (selectedExercises.includes(exercise.name)) {
        exercise = this.getExercise("emom");
      }
      selectedExercises.push(exercise.name);

      // Calculate the Exercise rep range, and the weight (light, normal, heavy)
      var exerciseDesc = "";
      if (exercise.repRange) {
        var reps = Math.floor((Math.random() * (exercise.repRange[1] - exercise.repRange[0])) + exercise.repRange[0]);
        exerciseDesc += reps + " ";
      }
      exerciseDesc += exercise.name;

      // if there's a weight associated, add it
      if (exercise.weights) {
        exerciseDesc += " " + exercise.weights[0] + "#";
      }
      exercises.push(exerciseDesc);

    }
    return (<div>
      <b>{wodTitle}</b><br />
      {exercises.map((ex) => (
        <div>{ex}</div>
      ))}
    </div>);
  }

  genUpperBody() {
    var accessoryWod = ""
    var numAccessories = Math.floor((Math.random() * 1) + 1);
    var selectedAccessories = [];
    var exercises = [];

    // Calculate the number of rounds
    var accessoryWodTitle = Math.floor((Math.random() * 4) + 3) + " rounds of:";
    for (var i = 0; i < numAccessories; i++) {

      // Get the Exercise (Make sure it's not duplicated)
      var accessory = this.getAccessory("Upper Body");
      while (selectedAccessories.includes(accessory.name)) {
        accessory = this.getAccessory("Upper Body");
      }
      selectedAccessories.push(accessory.name);

      // Calculate the Exercise rep range, and the weight (light, normal, heavy)
      if (accessory.repRange) {
        var reps = Math.floor((Math.random() * (accessory.repRange[1] - accessory.repRange[0])) + accessory.repRange[0]);
        accessoryWod += reps + " ";
      }
      accessoryWod += accessory.name;

      // if there's a weight associated, add it
      if (accessory.weights) {
        accessoryWod += " " + accessory.weights[0] + "#";
      }

      exercises.push(accessoryWod);
    }

    return (<div>
      {accessoryWodTitle}<br />
      {exercises.map((ex) => (
        <div>{ex}</div>
      ))}
    </div>);

  }

  genLowerBody() {
    var accessoryWod = ""
    var numAccessories = Math.floor((Math.random() * 1) + 1);
    var selectedAccessories = [];
    var exercises = [];

    // Calculate the number of rounds
    var accessoryWodTitle = Math.floor((Math.random() * 4) + 3) + " rounds of:";
    for (var i = 0; i < numAccessories; i++) {

      // Get the Exercise (Make sure it's not duplicated)
      var accessory = this.getAccessory("Lower Body");
      while (selectedAccessories.includes(accessory.name)) {
        accessory = this.getAccessory("Lower Body");
      }
      selectedAccessories.push(accessory.name);

      // Calculate the Exercise rep range, and the weight (light, normal, heavy)
      if (accessory.repRange) {
        var reps = Math.floor((Math.random() * (accessory.repRange[1] - accessory.repRange[0])) + accessory.repRange[0]);
        accessoryWod += reps + " ";
      }
      accessoryWod += accessory.name;

      // if there's a weight associated, add it
      if (accessory.weights) {
        accessoryWod += " " + accessory.weights[0] + "#";
      }

      exercises.push(accessoryWod);
    }

    return (<div>
      {accessoryWodTitle}<br />
      {exercises.map((ex) => (
        <div>{ex}</div>
      ))}
    </div>);

  }


  copyToClipboard = () => {
    let wod = document.getElementById('wodHeader').innerText + " \n";
    wod += document.getElementById('wodText').innerText + " \n \n";
    
    wod += document.getElementById('accessoryHeader').innerText + " \n";
    wod += document.getElementById('accessoryText').innerText + " \n";

    wod += "www.woddini.com - Tell Your Bros";
    navigator.clipboard.writeText(wod);
  }

  genWod() {
    var wodType = ["For Time", "AMRAP", "EMOM"];


    // Randomly select a type of Wod.
    var randWodType = wodType[Math.floor((Math.random() * wodType.length) + 0)];

    var wod = "";
    // Each type has a different template
    if (randWodType === wodType[0]) {
      wod = this.genForTime();
    }
    if (randWodType === wodType[1]) {
      wod = this.genAmrap();
    }
    if (randWodType === wodType[2]) {
      wod = this.genEmom();
    }

    this.setState({
      wodTitle: randWodType,
      wodText: wod
    });
  }
  
  genAccessory() {
    var accessoryType = ["Upper Body", "Lower Body"];

    // Randomly select a type of Accessory.
    var randAccessoryType = accessoryType[Math.floor((Math.random() * accessoryType.length) + 0)];

    var accessoryWod = "";
    // Each accessory type has a different template
    if (randAccessoryType === accessoryType[0]) {
      accessoryWod = this.genUpperBody();
    }

    if (randAccessoryType === accessoryType[1]) {
      accessoryWod = this.genLowerBody();
    }


    this.setState({
      accessoryTitle: "Accessory: " + randAccessoryType,
      accessoryText: accessoryWod
    });

    return accessoryWod;
  }

  // Load random wod and Accessory
  refreshPage = () => {
    this.genWod();
    this.genAccessory();
  }

  // Run the algorithm once the site is rendered
  componentDidMount() {
    this.refreshPage();
  }

  render() {
    return (
      <div>
        <Navbar />
        <div className="App" >
          <header className="App-header">
            <Card>
              <CardHeader id="wodHeader" name="wodHeader"
                title={this.state.wodTitle}
                titleTypographyProps={{ align: 'center' }}
                subheaderTypographyProps={{
                  align: 'center',
                }}
                sx={{
                  backgroundColor: (theme) =>
                    theme.palette.grey[300]
                  ,
                }}
              />
              <CardContent id="wodText" name="wodText">
                <Typography
                  className={"MuiTypography--heading"}
                  variant={"h6"}
                >
                  {this.state.wodText}</Typography>
              </CardContent>
            </Card>
            <br />
            <Card>
              <CardHeader id="accessoryHeader" name="accessoryHeader"
                title={this.state.accessoryTitle}
                titleTypographyProps={{ align: 'center' }}
                subheaderTypographyProps={{
                  align: 'center',
                }}
                sx={{
                  backgroundColor: (theme) =>
                    theme.palette.grey[300]
                  ,
                }}
              />
              <CardContent id="accessoryText" name="accessoryText">
                <Typography
                  className={"MuiTypography--heading"}
                  variant={"h6"}
                >
                  {this.state.accessoryText}</Typography>
              </CardContent>
            </Card>
            <div className="Button-group">
              <button className="Button-wod" onClick={this.refreshPage}>Load Another Wod</button>
              <button className="Button-wod" onClick={() => {
              this.copyToClipboard();
              this.openSnackbar();
              }}>Copy Wod to clipboard</button>
                     <Snackbar 
                     open={this.state.snackbarIsOpen} 
                     autoHideDuration={6000} 
                     onClose={this.closeSnackbar}>
                        <Alert onClose={this.closeSnackbar} severity="success" sx={{ width: '100%' }}>
                          WOD copied to clipboard!
                        </Alert>
                      </Snackbar>
            </div>
          </header>
        <footer className="App-footer">
        <button className="modal-btn-primary" onClick={this.openModal}>Terms and Conditions</button>
        <Modal
          className="modal-dialog"
          closeTimeoutMS={150}
          isOpen={this.state.modalIsOpen}
          onRequestClose={this.handleModalCloseRequest}
          style={{
            overlay: {
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: 'rgba(255, 255, 255, 0.75)'
            },
            content: {
              position: 'absolute',
              top: '80px',
              left: '40px',
              right: '40px',
              bottom: '360px',
              border: '1px solid #ccc',
              background: '#fff',
              overflow: 'auto',
              WebkitOverflowScrolling: 'touch',
              borderRadius: '4px',
              outline: 'none',
              padding: '20px'
            }
          }}
        >
          <div className="modal-content">
            <div className="modal-body">
              <h4>Terms and Conditions</h4>
              <p>By accessing this website, you expressly acknowledge that Woddini does not share medical advice. Seek the advice of a medical professional before engaging in any strenuous exercise.</p>
              <p>Woddini is distributed under the MIT License. Copyright 2021.</p>
            </div>
            <div className="modal-footer">
              <button className="modal-btn-secondary" onClick={this.handleModalCloseRequest}>Close</button>
            </div>
          </div>
        </Modal>
        </footer>
        </div>
      </div>
    );
  }
}

ReactDOM.render(
  <React.StrictMode>
    <WodGenerator />
  </React.StrictMode>,
  document.getElementById('root')
);